import { schema } from 'normalizr';

const content = new schema.Entity(
  'contents',
  {},
  {
    processStrategy: (value: any, parent: any, key: string) => {
      let result = {
        ...value,
        value: undefined
      };
      switch (key) {
        case 'instructions':
        case 'hints':
          result.url = `${parent.sectionId}/${parent.id}/${value.id}.html`;
          break;
        case 'children':
          result.url = `${parent.sectionId}/${parent.id}/${value.id}.html`;
          break;
        case 'questionContent':
          result.url = `${parent.sectionId}/${parent.id}/content.html`;
          break;
        case 'correctFeedback':
          result.url = `${parent.sectionId}/${parent.id}/correctFeedback.html`;
          break;
        case 'incorrectFeedback':
          result.url = `${parent.sectionId}/${parent.id}/incorrectFeedback.html`;
          break;
        default:
          throw new Error('Content entity key is not supported');
      }
      return result;
    }
  }
);

content.define({
  children: [content]
});

export default content;
